<template>
    <div id="inativar-beneficiario">
        <b-modal id="modal-inativar-beneficiario" centered body-class="body-class container inativar-beneficiario-modal" :visible="true" hide-header
        no-close-on-backdrop no-close-on-esc @hidden="$emit('close')">

            <DynamicIcon icon="exclamation" :classString="'alert-exclamation inativacao-beneficiario'"/>

            <p class="text-center mb-3" v-if="beneficiario.tipoId == 1">
               Tem certeza que deseja inativar <b class="optum-bold">{{beneficiario.nome}}</b> e os seus dependentes?
            </p>

            <p class="text-center mb-3" v-else>
               Tem certeza que deseja inativar o dependente?
            </p>

            <div v-if="dependentes.length" class="row m-0 w-100">
                <div v-for="item in dependentes" :key="item.id" class="w-100 d-flex justify-content-between text-inativacao">
                    <b class="optum-bold">{{item.nome}}</b>
                    <p>{{formatarCPF(item.cpf)}}</p>
                </div>
            </div>

            <ModalAlert id="inativar-beneficiario-alert" @close="$bvModal.hide('modal-inativar-beneficiario')">
                <DynamicIcon :icon="!errors ? 'check' : 'exclamation'" :classString="'alert-exclamation'"/>
                    <p class="text-center w-100">
                        <b>{{beneficiario.nome}}</b> foi inativado. 
                    </p>
            </ModalAlert>

            <template #modal-footer>
                <b-button pill class="btn-base outline-primary-btn " @click="$bvModal.hide('modal-inativar-beneficiario')">Não</b-button>
                <b-button pill class="btn-base primary-btn" @click="inativar">Sim</b-button>
            </template>	
    
        </b-modal>
        <ModalAlert id="modal-response-message-error" @close="finalizarImportacao">
          <DynamicIcon icon="not" :classString="'alert-exclamation'"/>
          {{ responseMessage }}
      </ModalAlert>
    </div>
</template>

<script>

import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import ModalAlert from "@/components/commons/ModalAlert.vue";
import BeneficiarioImportacaoResource from "@/resources/BeneficiarioImportacaoResource";
import Validations from "@/util/Validations";

export default {
    name: 'ModalInativarBeneficiario',
    props: { 
        beneficiario: {
            type: [Object],
            required: false,
            default: null,
        }
    },
    components: {
        DynamicIcon,
        ModalAlert
    },
    data (){
        return {
            responseMessage: null,
            errors: null,
            message: null,
            dependentes: [],
            headerFields: [
                {key: 'nome', label: "Nome"},
                {key: 'cpf', label: 'CPF'},
            ],
        }
    },
    computed: {
        titleByTipoBeneficiario () {
            return this.beneficiario.tipoId == 1 ? 'Funcionário' : 'Dependente'
        }
    },
    methods : {
        inativar () {
            this.beneficiario.acao = "INATIVAR"
            BeneficiarioImportacaoResource.inativar( this.beneficiario, {showLoader: true})
            .then(response => {

                if(response.success)
                {
                    this.errors = false
                    this.message = "Usuário inativado com sucesso."
                    this.$bvModal.show("inativar-beneficiario-alert")
                }
                this.$bvModal.show("cadastrar-beneficiario-alert");

            }).catch(err => {
                console.log(err)
                this.showModalError(err)
            })
        },
        formatarCPF(cpf) {
            // Remove qualquer caractere não numérico do CPF
            cpf = cpf.replace(/\D/g, '');

            // Adiciona pontos e traço conforme o formato padrão
            cpf = cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');

            return cpf;
        },
        showModalError(err) {
			this.responseMessage = Validations.getMessageError(err.errors[0])
            this.$bvModal.hide("inativar-beneficiario-alert")
            this.$bvModal.hide("cadastrar-beneficiario-alert");
			this.$bvModal.show('modal-response-message-error')
		}
    },
    mounted() {
        if(this.beneficiario.tipoId == 1)
        {
            BeneficiarioImportacaoResource.dependentes( this.beneficiario.id, {showLoader: false})
            .then(response => {
                if(response.length > 0)
                   this.dependentes = response.filter(elem => { return { nome: elem.nome, cpf: elem.cpf } } )
            }).catch(err => {
                console.log(err)
            })
        }
    }
}
</script>

<style>
html body #modal-inativar-beneficiario .modal-dialog{
    min-width: 650px !important;
}
</style>

<style scoped>
.text-inativacao b{
    font-size: 0.80rem;
}

.alert-exclamation.inativacao-beneficiario{
    height: 90px;
}
</style>